import axiosInstance from "./axios-instance";

export interface PleneTextResponse {
  text: string;
}

export const fetchPleneText = async (origin_table: string, origin_id: number): Promise<PleneTextResponse> => {
  try {
    let endpoint = `/get-plene-text/${origin_id}`;
    const response = await axiosInstance.get(endpoint);
    const result = { text: response.data.data };
    return result;
  } catch (error: unknown) {
    const errorMessage = error instanceof Error ? error.message : 'Unknown error';
    console.error(
      `Error fetching content for plene text`,
      errorMessage
    );
    throw error;
  }
};

